const finderSidebarEL = document.querySelectorAll('[data-behaviour="finder-sidebar"]');

if( finderSidebarEL.length > 0 ) {

    finderSidebarEL.forEach((sidebar) => {

        const toggle = sidebar.querySelector('[data-behaviour="finder-sidebar-toggle"]');
        const content = sidebar.querySelector('[data-behaviour="finder-sidebar-content"]');

        if( toggle && content ) {

            toggle.addEventListener('click', (e) => {

                e.preventDefault();
                e.stopImmediatePropagation();
                sidebar.toggleAttribute('open');
        
            });

        }
    });

}